module.exports = __webpack_public_path__ + "static/media/filip.cb7f344f.jpg";